import React from 'react';
import PropTypes from 'prop-types';
import ReactPannellum from 'react-pannellum';

const PhotosphereViewer = ({
  path,
  id,
}) => {
  const config = {
    autoLoad: true,
    autoRotate: -2,
  };

  return (
    <ReactPannellum
      id={id}
      sceneId={id}
      imageSource={path}
      config={config}
      style={{
        width: '100%',
        height: '100%',
      }}
    />
  );
};

PhotosphereViewer.propTypes = {
  path: PropTypes.string,
  id: PropTypes.string,
};

export default PhotosphereViewer;
